import {
    Directive,
    ElementRef,
    Input, OnDestroy,
    Renderer2
} from "@angular/core";
import {MainHelper} from "../models/main-helper";

@Directive({
    selector: '[btTooltip]'
})
export class BootstrapTooltipDirective implements OnDestroy{
    constructor(public elementRef: ElementRef, public readonly renderer: Renderer2){
        this.helper = new MainHelper();
        this.renderer.setAttribute(this.elementRef.nativeElement, 'data-toggle', 'tooltip');
        this.renderer.setAttribute(this.elementRef.nativeElement, 'data-html', 'true');
        this.renderer.listen(this.elementRef.nativeElement, 'mouseleave', (event: MouseEvent) =>{
            $(this.elementRef.nativeElement).tooltip('hide');
        });
    }

    @Input('btTooltip')
    set setContainer(container: string){
        if (container){
            return;
        }
        this.renderer.setAttribute(this.elementRef.nativeElement, 'data-container', container)
    }

    @Input('disabled')
    set disabled(val: boolean){
        val && $(this.elementRef.nativeElement).tooltip('hide');
        val
            ? this.renderer.setAttribute(this.elementRef.nativeElement, 'disabled', 'true')
            : this.renderer.removeAttribute(this.elementRef.nativeElement, 'disabled')
    }

    @Input('title')
    set title(title: string){
        $(this.elementRef.nativeElement).tooltip('dispose');
        this.renderer.removeAttribute(this.elementRef.nativeElement, 'title');
        if (title){
            this.renderer.setAttribute(this.elementRef.nativeElement, 'title', title);
            this.helper.wait(() => $(this.elementRef.nativeElement).tooltip({
                trigger: 'hover',
                offset: "0, 0",
                template: '<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
            }))
        }
    }

    ngOnDestroy(){
        $(this.elementRef.nativeElement).tooltip('dispose')
    }

    private helper: MainHelper;
    private listener: () => void;
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/bootstrap-tooltip.directive.ts